module.exports = __webpack_public_path__ + "static/media/web-backing.13241937.png";